import type React from 'react';
import type { ADigitProps } from '../../atoms/ADigit/ADigit.types';
import type { ABodyProps } from '../../atoms/ABody/ABody.types';

export enum MTimerAlignment {
  Left = 'Left',
  Centered = 'Centered',
}

export interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

export interface MTimerProps extends React.HTMLAttributes<HTMLDivElement> {
  alignment?: MTimerAlignment;
  aDigit?: ADigitProps;
  aBody?: ABodyProps;
  targetDate?: string;
  daysLabel?: string;
  hoursLabel?: string;
  minutesLabel?: string;
  secondsLabel?: string;
  updateInterval?: number;
  screenReaderInterval?: number;
  onComplete?: () => void;
  isAuthorMode?: boolean;
  isLoading?: boolean;
  bodyText?: string;
}
